import React from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';
import { getDownloadLink } from '../../../utils/api';

// Create styles
const styles = StyleSheet.create({
  page: {
    width: '100%',
    flexDirection: 'column',
    backgroundColor: '#ffff',
    padding: 40,
    alignContent: 'center'
  },
  section: {
    marginBottom: 20,
  },
  model: {
    flexDirection: 'column',
    width: 90, // slightly wider
    height: 130,
    marginVertical: 10,
    marginHorizontal: 18,
    backgroundColor: '#f0f0f0',
  },
  image: {
    width: '100%',
    height: 90,
    objectFit: 'cover',
  },
  images: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%'
  },
  modelname: {
    padding: 5,
    flexDirection: 'column',
    textAlign: 'left',
    width: '100%',
    height: 'auto',
    fontSize: 9,
  },
  line: {
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    borderBottomStyle: 'solid',
    width: '40%',
    flexGrow: 1
  },
});

const fetchThumbnailUrl = (model) => {
  if (model.smallThumb && model.smallThumb.file) {
    const file = model.largeThumb.file;
    return getDownloadLink(file);
  }
  return '';
};

// Create Document Component
const PDFBooking = ({ models = [], booking = {}, timeline = {} }) => (
  <Document>
    {/** list of models in the booking */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.section}>
        <Text>PDF EXPORT: {booking.pool_id}</Text>
      </View>

      <View style={styles.images}>
        {models.map((model) => (
          <View style={styles.model} key={model.id + "PDF"}>
            <Image style={styles.image} src={fetchThumbnailUrl(model)} />
            <View style={styles.modelname}>
              <Text>{model.firstName || 'N/A'}</Text>
              <Text>{model.lastName || 'N/A'}</Text>
              <Text>{`Id: ${model.internalId || 'N/A'}`}</Text>
            </View>
          </View>
        ))}
        {models.map((model) => (
          <View style={styles.model} key={model.id + "PDF"}>
            <Image style={styles.image} src={fetchThumbnailUrl(model)} />
            <View style={styles.modelname}>
              <Text>{model.firstName || 'N/A'}</Text>
              <Text>{model.lastName || 'N/A'}</Text>
              <Text>{`Id: ${model.internalId || 'N/A'}`}</Text>
            </View>
          </View>
        ))}
        {models.map((model) => (
          <View style={styles.model} key={model.id + "PDF"}>
            <Image style={styles.image} src={fetchThumbnailUrl(model)} />
            <View style={styles.modelname}>
              <Text>{model.firstName || 'N/A'}</Text>
              <Text>{model.lastName || 'N/A'}</Text>
              <Text>{`Id: ${model.internalId || 'N/A'}`}</Text>
            </View>
          </View>
        ))}
      </View>

      {/* Line below model list */}
      <View style={styles.line} />
    </Page>

    {/** timeline of the booking */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.section}>
        <Text>Timeline: {booking.id}</Text>
      </View>

      {timeline.map((entry, index) => (
        <View key={`timeline-${index}`} style={{ marginBottom: 30 }}>
          {/* Date Header */}
          <Text style={{
            fontSize: 12,
            marginBottom: 10,
            fontWeight: 'bold',
            textAlign: 'left',
          }}>
            {entry.date} – {entry.address}
          </Text>

          {/* No model message */}
          {entry.models.length === 0 ? (
            <View style={{
              backgroundColor: '#e0e0e0',
              padding: 10,
              borderRadius: 4,
            }}>
              <Text style={{ textAlign: 'center', fontSize: 10 }}>No Model for this Date</Text>
            </View>
          ) : (
            <View style={styles.images}>
              {entry.models.map((model) => (
                <View style={styles.model} key={model.id + "-timeline"}>
                  <Image style={styles.image} src={fetchThumbnailUrl(model)} />
                  <View style={styles.modelname}>
                    <Text>{model.firstName || 'N/A'}</Text>
                    <Text>{model.lastName || 'N/A'}</Text>
                    <Text>{`Id: ${model.internalId || 'N/A'}`}</Text>
                  </View>
                </View>
              ))}
            </View>
          )}
        </View>
      ))}

    </Page>

  </Document>
);

export default PDFBooking;
